import { useQuery } from '@apollo/client';
import { Button, Select } from 'antd';
import { map, omit } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../AppContext';
import {
  PROJECT_DATA,
  ROUTES,
  SOURCE_TYPE,
  TOPIC_DATA,
} from '../../../common/constants';
import InfiniteSelect from '../../../components/InfiniteSelect';
import useRouter from '../../../hooks/useRouter';
import { GET_PROJECTS, GET_TOPICS } from '../graphql/Queries';

export default function ProjectBranchSelection({
  selectedProjectTopics,
  setSelectedProjectTopics,
  setSourceType,
  setSelectedTopics,
  setTopicId,
  setSelectedProject,
  selectedProject,
  setSelectedBranch,
  environments,
  environmentLoading,
  selectedBranch,
  setActionId,
}) {
  const {
    navigate,
    location: { state },
  } = useRouter();
  const { setProjectTopicId } = useContext(AppContext);
  const [initialSelectedBranch, setInitialSelectedBranch] = useState([]);

  const { data: { projectTopics } = {}, loading: topicsLoading } = useQuery(
    GET_TOPICS,
    {
      skip: !selectedProject,
      variables: {
        where: {
          integrations: map(
            selectedProject?.projectData?.integrations,
            (item) => omit(item, '__typename'),
          ),
        },
      },
      onCompleted: (res) => {
        // eslint-disable-next-line no-undef
        localStorage?.setItem(SOURCE_TYPE, res?.projectTopics?.sourceType);
        setSourceType(res?.projectTopics?.sourceType);
      },
      fetchPolicy: 'network-only',
      onError() {},
    },
  );

  const handleFilter = () => {
    setSelectedBranch(initialSelectedBranch);
  };

  useEffect(() => {
    if (state?.topicRefId) {
      setSelectedProjectTopics(state?.topicRefId);
    }
  }, [state]);

  const handleProjectClear = () => {
    navigate(ROUTES.MAIN);
    // eslint-disable-next-line no-undef
    window.location.reload();
    // eslint-disable-next-line no-undef
    localStorage?.removeItem(PROJECT_DATA);
    // eslint-disable-next-line no-undef
    localStorage?.removeItem(TOPIC_DATA);
    // eslint-disable-next-line no-undef
    localStorage?.removeItem(SOURCE_TYPE);
    setSelectedProject(null);
    setSelectedProjectTopics(null);
    setSelectedBranch(null);
    setProjectTopicId(null);
    setTopicId(null);
  };

  const handleFilterClear = () => {
    setSelectedBranch(null);
  };

  const handleChange = (values) => {
    setInitialSelectedBranch(values);
    if (values?.length === 0) {
      setSelectedBranch([]);
    }
  };

  useEffect(() => {
    setInitialSelectedBranch(selectedBranch);
  }, [selectedBranch]);

  return (
    <>
      <div className="full-width d-flex gap-8 align-center justify-between">
        <div className="gap-8 d-flex">
          <InfiniteSelect
            allowSearch
            allowClear
            fetchPolicy="no-cache"
            query={GET_PROJECTS}
            variableSelector={({ skip, limit, search }) => ({
              data: { skip, limit, search },
            })}
            countSelector={(data) => data?.gitProjects?.count ?? 0}
            dataSelector={(data) =>
              data?.gitProjects?.data?.map((project) => ({
                label: project?.name ?? '',
                value: project?.integrations?.[0]?.referenceId ?? '',
                projectData: project,
              })) ?? []
            }
            placeholder="Select Project"
            className="selection"
            onClear={handleProjectClear}
            onChange={(project, projectData) => {
              setSelectedProject(projectData);
              setSelectedProjectTopics(null);
              setSelectedBranch(null);
              setProjectTopicId(null);
              setTopicId(null);
              if (projectData) {
                // eslint-disable-next-line no-undef
                localStorage?.setItem(
                  PROJECT_DATA,
                  JSON?.stringify(projectData),
                );
              }
            }}
            value={
              selectedProject ||
              JSON?.parse(localStorage?.getItem(PROJECT_DATA))
            }
          />
          <Select
            placeholder="Select Topic"
            className="topic-selection"
            disabled={!selectedProject}
            options={projectTopics?.projectTopic?.map((res) => ({
              value: res?.id,
              label: res?.topic?.name,
              topicsData: res,
            }))}
            loading={topicsLoading}
            value={!topicsLoading ? selectedProjectTopics : null}
            onSelect={(value, repoData) => {
              setSelectedTopics(repoData);
              setSelectedProjectTopics(value);
              setProjectTopicId(value);
              setTopicId(value);
              setInitialSelectedBranch(null);
              setSelectedBranch(null);
              setActionId(null);
              // eslint-disable-next-line no-undef
              localStorage?.setItem(TOPIC_DATA, JSON?.stringify(repoData));
            }}
          />
        </div>
        <div className="mr-16 gap-8 d-flex">
          <Select
            className="env-selection"
            mode="multiple"
            options={environments?.data?.map((env) => ({
              value: env?.id,
              label: env?.name,
            }))}
            value={initialSelectedBranch}
            loading={environmentLoading}
            placeholder="Select ENV"
            onChange={handleChange}
            allowClear
            onClear={handleFilterClear}
            optionFilterProp="label"
            maxTagCount="responsive"
          />
          <Button
            type="primary"
            onClick={handleFilter}
            disabled={initialSelectedBranch <= 0}
          >
            Filter
          </Button>
        </div>
      </div>
    </>
  );
}
